import { Formik } from "formik";
import { useDispatch } from "react-redux";
import { ERROR_MESSAGES, SETTINGS_MESSAGES } from "src/constants/messages";
import { NOTIFICATION_HEADERS } from "src/constants/notificationHeaders";
import { NOTIFICATION_TYPES } from "src/constants/notificationTypes";
import Api from "src/data/api";
import { showNotification } from "src/redux/notificationActions";

const updateRetailerWidgetSettings = async (data) => {
    await Api.request({
        method: "POST",
        url: `/retailer/settings/widget-config`,
        data,
    });
};

const RetailerWidgetConfigurationFormik = ({ widgetSettings, children }) => {
    const dispatch = useDispatch();
    return (
        <Formik
            enableReinitialize
            initialValues={{...widgetSettings }}
            onSubmit={async (values, { setSubmitting }) => {
                try {
                    await updateRetailerWidgetSettings(values);

                    dispatch(
                        showNotification(
                            SETTINGS_MESSAGES.UPDATE_WIDGET_SETTINGS,
                            NOTIFICATION_TYPES.SUCCESS,
                            NOTIFICATION_HEADERS.RETAILER_WIDGET_SETTINGS
                        )
                    );
                } catch (err) {
                    dispatch(
                        showNotification(
                            ERROR_MESSAGES.SOMETHING_WENT_WRONG,
                            NOTIFICATION_TYPES.ERROR,
                            NOTIFICATION_HEADERS.OOPS
                        )
                    );
                } finally {
                    setSubmitting(false);
                }
            }}
        >
            {children}
        </Formik>
    );
};

export default RetailerWidgetConfigurationFormik;
